import React, { useEffect } from "react";
import Rules from "../../sparkRule/Rules";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/other/Loader";
import HeroSection from "../../../layout/HeroSection";
import { useDispatch, useSelector } from "react-redux";
import { pageRoutes } from "../../../routes/pageRoutes";
import { fetchEventCoverage } from "../../../redux/action/moreAction";
import { fetchSparcRule } from "../../../redux/action/getStartAction";
import NoRecord from "../../../components/other/NoRecord";

const EventCoverageResults = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { eventCoverageList, isLoading } = useSelector(
    (state) => state?.moreReducer
  );

  useEffect(() => {
    dispatch(fetchEventCoverage());
    dispatch(fetchSparcRule());
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <div>
        <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Event Coverage/Results"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "Event Coverage/Results",
              path: `${pageRoutes?.home}/`,
            },
          ]}
        />

        <section className="untree_co-section product-section py-5">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2 class="section-title text-center mb-5">
                  <strong>Events</strong>
                </h2>
                <div className="row">
                  {eventCoverageList?.length > 0 ? (
                    <>
                      {eventCoverageList?.map((item) => (
                        <div className=" col-lg-4 col-md-6 mb-4">
                          <div
                            href={
                              item?.event_coverage_link ?? "javascript:void(0)"
                            }
                            className="ct_links_card  d-block"
                            target="__blank"
                          >
                            <a
                              href={
                                item?.event_coverage_link ??
                                "javascript:void(0)"
                              }
                              target="__blank"
                            >
                              <img src={item?.event_coverage_image} alt="" />
                            </a>
                            <h4 className="mb-0 mt-3">
                              {item?.event_coverage_title ?? ""}
                            </h4>
                          </div>
                        </div>
                      ))}
                    </>
                  ) : (
                    <NoRecord />
                  )}
                  {/* <div className=" col-lg-4 col-md-6 mb-4">
                    <a
                      href="https://www.robotcombatevents.com/"
                      className="ct_links_card  d-block"
                      target="__blank"
                    >
                      <a
                        href="https://www.robotcombatevents.com/"
                        target="__blank"
                      >
                        <img
                          src="https://robotcombat101.com/admin/public/cms_images/partners/679e9d598df2a.png"
                          alt=""
                        />
                      </a>
                      <h4 className="mb-0 mt-3">RobotCombatEvents.com</h4>
                    </a>
                  </div>
                  <div className=" col-lg-4 col-md-6 mb-4">
                    <a
                      href="https://battlebots.com/events/"
                      target="__blank"
                      className="ct_links_card  d-block"
                    >
                      <a href="https://battlebots.com/events/" target="__blank">
                        <img
                          src="images/cropped-BB-Favicon-2020-1-180x180.png"
                          alt=""
                        />
                      </a>
                      <h4 className="mb-0 mt-3">battlebots.com</h4>
                    </a>
                  </div> 
                  <div className=" col-lg-4 col-md-6 mb-4">
                    <a
                      href="https://www.nhrl.io/events"
                      target="__blank"
                      className="ct_links_card d-block"
                    >
                      <a href="https://www.nhrl.io/events" target="__blank">
                        <img
                            src="https://robotcombat101.com/admin/public/cms_images/partners/679e9d598df2a.png"
                            alt=""
                          /> 
                        <svg
                          width="300"
                          height="100"
                          viewBox="0 0 400 235"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="navbar_logo__oMk12"
                        >
                          <path
                            d="M77.8252 0V47.3652L47.8862 0.0400866V0H0V39.2934L47.8862 114.857V75.735L77.8252 123.057V123.135H77.8741L77.9 123.175L125.714 123.135V0H77.8252Z"
                            fill="#281B5E"
                          ></path>
                          <path
                            d="M360.333 195.933L312.381 120.635V210.91L327.646 234.92H400V195.967L360.333 195.933Z"
                            fill="#281B5E"
                          ></path>
                          <path
                            d="M211.542 0V42.0359H182.112V0H134.603V123.175H182.112V81.1387H211.542V103.053H259.048V0H211.542Z"
                            fill="#281B5E"
                          ></path>
                          <path
                            d="M316.19 111.746H360.635V180.318L316.19 111.746Z"
                            fill="#00DAD8"
                          ></path>
                          <path
                            d="M43.1746 123.174H0V54.603L43.1746 123.174Z"
                            fill="#CF23CA"
                          ></path>
                          <path
                            d="M288.195 186.654C299.113 178.697 303.576 166.783 303.576 154.308C303.576 132.383 289.802 112.184 251.403 112.184L193.016 111.746L193.094 234.921H241.043V196.987L265.1 234.921L318.73 234.803L288.195 186.654ZM251.268 162.075H241.043V146.46L251.268 146.54C258.348 146.54 260.887 150.264 260.887 154.308C260.887 158.352 258.348 162.075 251.268 162.075Z"
                            fill="#281B5E"
                          ></path>
                        </svg>
                      </a>
                      <h4 className="mb-0 mt-3">nhrl.io</h4>
                    </a>
                  </div>*/}
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="untree_co-section product-section pb-5 pt-0">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2 class="section-title text-center mb-5">
                  <strong>League Rules</strong>
                </h2>
              </div>
            </div>
            <Rules />
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default EventCoverageResults;
